import type { ReactNode } from "react";

export const substitute = (pattern: string, replacements: { [key: string]: ReactNode }) => {
    const parts = pattern.split(/\{(\d+)\}/g);
    return parts.map((part) => {
        const match = replacements[`${part}`];
        return match ? match : part;
    });
};
